// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b1ebae73","453":"1f1ce442","535":"ffd4bcac"}[chunkId] + ".chunk.js";
};